import { DateTime } from "luxon";

export const currencyFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
}).format;

export const dateFormat = (date: string) =>
  DateTime.fromISO(date, { zone: "utc" }).setLocale("en-US").toFormat("DD");

export const nameDayDateFormat = (date: string) =>
  DateTime.fromISO(date, { zone: "utc" })
    .setLocale("en-US")
    .toFormat("ccc, MMM d");

export const nameDayCompleteDateFormat = (date: string) =>
  DateTime.fromISO(date, { zone: "utc" })
    .setLocale("en-US")
    .toFormat("ccc, LL/dd/yyyy");

export const numDayShortMonthDateFormat = (date: string) =>
  DateTime.fromISO(date, { zone: "utc" }).setLocale("en-US").toFormat("d MMM");

export const numDayShortMonthWithYearDateFormat = (date: string) =>
  DateTime.fromISO(date, { zone: "utc" })
    .setLocale("en-US")
    .toFormat("d MMM yy");

export const dateFormatWithHours = (date: string) =>
  DateTime.fromISO(date, { zone: "utc" })
    .setZone("America/New_York")
    .toFormat("LLL d, yyyy 'at' h:mm a");

export const dateFormatWithHoursForExcelQuery = (date: string) =>
  DateTime.fromFormat(date, "MM/dd/yyyy HH:mm:ss Z", { zone: "utc" })
  .setZone("America/New_York")
  .toFormat("MM/dd/yyyy h:mm a");

export const dateFormatLocal = (date: string) =>
  DateTime.fromISO(date).setLocale("en-US").toFormat("DD");

export const dateFormatLocalToSort = (date: string) =>
  DateTime.fromISO(date, {
    zone: "America/New_York",
    locale: "en-US",
  }).toFormat("yyyy/LL/dd, t");

export const dateFormatEntryEdit = (date: string) =>
  DateTime.fromISO(date, {
    zone: "utc",
    locale: "en-US",
  }).toFormat("LL/dd/yyyy");

export const timeAmountFormat = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}).format;

export const quantityFormat = timeAmountFormat;

export const formatForDropdowns: <T extends { id: number }>(
  key: Exclude<keyof T, "id">
) => (item: T) => { value: string; label: string } = (key) => (item) => ({
  value: "" + item.id,
  label: "" + item[key],
});

export const activityLogFormat = (activity: string) =>
  // remove Invoice word just to avoid redundance
  activity
    .replace("Invoice", "")
    .match(/[A-Z][a-z]+|[0-9]+/g)
    ?.join(" ");

export const decodeURIComponentSafe = (text) => {
  try {
    return decodeURIComponent(text);
  } catch (e) {
    const sanitized = text.replace(/%(?![0-9][0-9a-fA-F]+)/g, "%25");
    return decodeURIComponent(sanitized);
  }
};

// To format dates from mongo with this format (05/02/2025 21:22:20 +00:00)
export const formatDateToCustomString = (input) => {
  // Strip the timezone part
  const [datePart, timePart] = input.split(" ");
  const [month, day, year] = datePart.split("/").map(Number);
  const [hour, minute, second] = timePart.split(":").map(Number);

  // Create a Date object in UTC
  const date = new Date(Date.UTC(year, month - 1, day, hour, minute, second));

  // Format to MM-DD-YYYY HH:mm:ss
  const pad = (n) => String(n).padStart(2, "0");
  const formatted = `${pad(date.getUTCMonth() + 1)}-${pad(
    date.getUTCDate()
  )}-${date.getUTCFullYear()} ${pad(date.getUTCHours())}:${pad(
    date.getUTCMinutes()
  )}:${pad(date.getUTCSeconds())}`;

  return formatted;
};

export const getTodayFormatted = () => {
  const today = new Date();
  const options = { month: "short" as const };
  const month = today.toLocaleString("en-US", options); // e.g. "Sep"
  const day = String(today.getDate()).padStart(2, "0"); // always 2 digits
  const year = today.getFullYear();
  return `${month} ${day} ${year}`;
};

export const hideArrowInSelectReadOnly = (isReadOnly: boolean) => {
  return isReadOnly
    ? {
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }
    : {};
};

export const generateTitleUSReport = (
  isSalaried: boolean,
  startDateISO: any,
  endDateISO: any
) => {
  // Convertir las fechas ISO a objetos Date
  const start = new Date(startDateISO);
  const end = new Date(endDateISO);

  // Función auxiliar para formatear YYYYMMDD
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}${month}${day}`;
  };

  // Generar el título
  return `US Payroll Export - ${
    isSalaried ? "Salaried" : "Hourly"
  } - ${formatDate(start)}_${formatDate(end)}`;
};
